export default __webpack_public_path__ + "static/media/bg_banner.907fcfeb.jpg";